import Component from '../share/Component';
import stripIndent from 'licia/stripIndent';
import $ from 'licia/$';
import escape from 'licia/escape';
import isNum from 'licia/isNum';
import { measuredScrollbarWidth, exportCjs } from '../share/util';
export default class Tab extends Component {
    constructor(container, options = {}) {
        super(container, { compName: 'tab' }, options);
        this.initOptions(options, {
            height: 30,
        });
        this.initTpl();
        this.$tabs = this.find('.tabs');
        this.tabs = this.$tabs.get(0);
        this.$slider = this.find('.slider');
        this.bindEvent();
        this.updateHeight();
    }
    get length() {
        return this.$tabs.find(this.c('.item')).length;
    }
    insert(pos, tab) {
        const { c, $tabs } = this;
        const itemHeight = this.options.height - 1;
        const $items = $tabs.find(c('.item'));
        const len = $items.length;
        const html = `<div class="${this.c('item')}" data-id="${escape(tab.id)}" style="height: ${itemHeight}px; line-height: ${itemHeight}px;">${escape(tab.title)}</div>`;
        if (pos > len - 1) {
            $tabs.append(html);
        }
        else {
            $items.eq(pos).before(html);
        }
        this.updateSlider();
    }
    append(tab) {
        this.insert(this.length, tab);
    }
    remove(id) {
        const { c } = this;
        const self = this;
        this.$tabs.find(c('.item')).each(function () {
            const $this = $(this);
            if ($this.data('id') === id) {
                if ($this.hasClass(c('selected'))) {
                    if (self.length > 0) {
                        const id = self.$tabs.find(c('.item')).eq(0).data('id');
                        self.select(id);
                    }
                    else {
                        self.emit('deselect');
                    }
                }
                $this.remove();
            }
        });
        this.updateSlider();
    }
    select(id) {
        const { c } = this;
        const self = this;
        this.$tabs.find(c('.item')).each(function () {
            const $this = $(this);
            if ($this.data('id') === id) {
                $this.addClass(c('selected'));
                self.updateSlider();
                self.scrollToSelected();
                self.emit('select', id);
            }
            else {
                $this.rmClass(c('selected'));
            }
        });
    }
    scrollToSelected() {
        const { $tabs, tabs, c } = this;
        const item = $tabs.find(c('.selected')).get(0);
        const itemLeft = item.offsetLeft;
        const itemWidth = item.offsetWidth;
        const containerWidth = tabs.offsetWidth;
        const scrollLeft = tabs.scrollLeft;
        let targetScrollLeft;
        if (itemLeft < scrollLeft) {
            targetScrollLeft = itemLeft;
        }
        else if (itemLeft + itemWidth > containerWidth + scrollLeft) {
            targetScrollLeft = itemLeft + itemWidth - containerWidth;
        }
        if (!isNum(targetScrollLeft)) {
            return;
        }
        tabs.scrollLeft = targetScrollLeft;
    }
    hideScrollbar() {
        const { $tabs } = this;
        if (getComputedStyle(this.tabs, '::-webkit-scrollbar').display === 'none') {
            return;
        }
        const scrollbarHeight = measuredScrollbarWidth();
        $tabs.css('height', this.options.height - 1 + scrollbarHeight + 'px');
    }
    updateSlider() {
        const { $slider, $tabs, c } = this;
        const selected = $tabs.find(c('.selected')).get(0);
        if (!selected) {
            $slider.css({ width: 0 });
            return;
        }
        $slider.css({
            width: selected.offsetWidth,
            left: selected.offsetLeft - $tabs.get(0).scrollLeft,
        });
    }
    updateHeight() {
        const { height } = this.options;
        const itemHeight = height - 1;
        this.find('.tabs-container').css('height', height + 'px');
        this.find('.item').css({
            height: itemHeight,
            lineHeight: itemHeight,
        });
        this.hideScrollbar();
    }
    bindEvent() {
        const { tabs, c } = this;
        this.on('optionChange', (name) => {
            switch (name) {
                case 'height':
                    this.updateHeight();
                    break;
            }
        });
        const self = this;
        this.$tabs
            .on('wheel', function (e) {
            e.preventDefault();
            tabs.scrollLeft += e.origEvent.deltaY;
        })
            .on('click', c('.item'), function () {
            const $item = $(this);
            self.select($item.data('id'));
        })
            .on('scroll', () => {
            this.updateSlider();
        });
    }
    initTpl() {
        this.$container.html(this.c(stripIndent `
        <div class="tabs-container">
          <div class="tabs"></div>
        </div>
        <div class="slider"></div>
      `));
    }
}
if (typeof module !== 'undefined') {
    exportCjs(module, Tab);
}
